module.exports = __webpack_public_path__ + "img/re-result-3.32744143.jpg";